import axios from "axios";
import { pbxAuthHeader } from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_PBX_API;

class MediaSerices {
  // intent media file url generate
  async mediaFileUrlGenerate(data, domain_uuid) {
    const response = await axios.post(
      API_URL + "pbx-service/media/upload",
      data,
      {
        headers: pbxAuthHeader(domain_uuid),
      }
    );
    return response.data;
  }
  // update intent
  async mediaFileUpload(URL, data) {
    const response = await axios.put(URL, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  //  RECOREDING RELATED APIs

  // get Recoreding list
  getRecoredingList(domain_uuid) {
    return axios
      .get(API_URL + `call-app/media/recording`, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add Recoreding
  addRecoreding(data, domain_uuid) {
    return axios
      .post(API_URL + `call-app/media/recording`, data, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete Recoreding
  deleteRecoreding(data, domain_uuid) {
    return axios
      .delete(API_URL + `call-app/media/recording`, data, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }

  //  MUSIC ON HOLD RELATED APIs

  // get music on hold list
  getMohList(domain_uuid) {
    return axios
      .get(API_URL + `call-app/media/moh`, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add music on hold
  addMoh(data, domain_uuid) {
    return axios
      .post(API_URL + `call-app/media/moh`, data, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete music on hold
  deleteMoh(data, domain_uuid) {
    return axios
      .delete(API_URL + `call-app/media/moh`, data, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new MediaSerices();
